import type { NotificationCategory } from '../../types/notifications'

/**
 * Human fallback titles for a notification row, keyed by category. The
 * backend supplies a human `title` on every row it creates; this map is the
 * safety net so a row with a null title still renders a friendly string
 * instead of a raw codename (e.g. "bulk_ops_done" -> "Bulk operation done").
 */
const CATEGORY_TITLE: Record<NotificationCategory, string> = {
  sync_completed: 'Sync completed',
  sync_failed: 'Sync failed',
  report_ready: 'Report ready',
  export_ready: 'Export ready',
  bulk_ops_done: 'Bulk operation done',
  feedback_reply: 'Feedback reply',
  feedback_received: 'New feedback',
  user_created: 'New user',
}

/** Title to show for a row: the backend title, else a category fallback. */
export function notificationTitle(
  category: NotificationCategory,
  title: string | null,
): string {
  const trimmed = title?.trim()
  if (trimmed) return trimmed
  return CATEGORY_TITLE[category] ?? 'Notification'
}
